module.exports = __webpack_public_path__ + "static/media/screen1.9732173b.jpg";